import { useContext, useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { FC } from "react";
import { QESButton, QESRadioButton } from "@app/shared/qes-standards";
import { AdequacyQueryShape } from "@app/projects/CountyProjectContainer";
import { FlyoutContext } from "@app/shared/Flyouts";
import { querystringify, parseQuerystring } from "@app/shared/utility";
import { SpecialtyTypeEnum } from "@app/projects/enumerators";

const SpecialtyFilter: FC = () => {
  const location = useLocation();
  const history = useHistory();
  const actionMenuContext = useContext(FlyoutContext);

  const getInitialSelected = () => {
    const query = parseQuerystring(location.search) as AdequacyQueryShape;
    if (query.specialtyType === SpecialtyTypeEnum.Informational || query.specialtyType === SpecialtyTypeEnum.Required) {
      return query.specialtyType;
    }
    return SpecialtyTypeEnum.All;
  };

  const [selected, setSelected] = useState<SpecialtyTypeEnum>(getInitialSelected);

  useEffect(() => {
    const query = parseQuerystring(location.search) as AdequacyQueryShape;
    if (query.specialtyType === SpecialtyTypeEnum.Informational || query.specialtyType === SpecialtyTypeEnum.Required) {
      setSelected(query.specialtyType);
    } else {
      setSelected(SpecialtyTypeEnum.All);
    }
  }, [location.search]);

  const updateQuery = () => {
    let query = parseQuerystring(location.search) as AdequacyQueryShape;

    query = {
      ...query,
      specialtyType: selected,
    };

    const qs = querystringify(query as { [key: string]: unknown });
    history.push({
      ...history.location,
      search: qs,
    });
    actionMenuContext.handleCloseFlyout();
  };

  return (
    <>
      <div className="col-12 mb20">
        <QESRadioButton
          label="All Specialties"
          onChange={() => setSelected(SpecialtyTypeEnum.All)}
          checked={selected === SpecialtyTypeEnum.All}
          testId="all-specialties-filter"
          name="specialty-type"
        />
        <QESRadioButton
          label="Informational Specialties"
          onChange={() => setSelected(SpecialtyTypeEnum.Informational)}
          checked={selected === SpecialtyTypeEnum.Informational}
          testId="informational-specialties-filter"
          name="specialty-type"
        />
        <QESRadioButton
          label="Required Specialties"
          onChange={() => setSelected(SpecialtyTypeEnum.Required)}
          checked={selected === SpecialtyTypeEnum.Required}
          testId="required-specialties-filter"
          name="specialty-type"
        />
      </div>
      <div className="px-1">
        <QESButton qesType="primary" qesTestId="specialty-filter__apply" onClick={updateQuery} className="col-12">
          Apply
        </QESButton>
      </div>
    </>
  );
};

export default SpecialtyFilter;